import { CreateUpdateUserRequest } from '@src/main/modules/user/infrastructure/dto/createUpdateUserRequest';
import { createUserHttpRepository } from '@src/main/modules/user/infrastructure/UserHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const updateUserUseCase = async (
  id: string,
  data: CreateUpdateUserRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createUserHttpRepository(tokenProvider);
  return await repository.update(id, data);
};
